function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#1F2947",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.004 4.004h-10.17a3 3 0 0 0-5.66 0H7.004a1 1 0 1 0 0 2h10.17a3 3 0 0 0 1.83 1.82v28.18h-9a1 1 0 0 0 0 2h20a1 1 0 1 0 0-2h-9V7.824a3 3 0 0 0 1.83-1.82h10.17a1 1 0 1 0 0-2zm-13 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.004 10.254 4 9.75h-8l4-9.75m0-5.25-6.18 15-.41 1-.38.93-.03.07a.49.49 0 0 0 0 .12v2.88a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-2.88a.49.49 0 0 0 0-.12.19.19 0 0 0 0-.07l-.41-.93-.41-1-6.18-15zm-4 21a1 1 0 0 1-1-1v-2.41a.58.58 0 0 1 .59-.59h8.82a.58.58 0 0 1 .59.59v2.41a1 1 0 0 1-1 1h-8zM8.004 10.254l4 9.75h-8l4-9.75m0-5.25-6.18 15-.41 1-.41.93v.07a.49.49 0 0 0 0 .12v2.88a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-2.88a.49.49 0 0 0 0-.12.19.19 0 0 0 0-.07l-.41-.93-.41-1-6.18-15zm-4 21a1 1 0 0 1-1-1v-2.41a.58.58 0 0 1 .59-.59h8.82a.58.58 0 0 1 .59.59v2.41a1 1 0 0 1-1 1h-8z"
}));
const SvgDecisionTime = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDecisionTime, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/decision-time.3efd84e3.svg";
export { ForwardRef as ReactComponent };